import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios'; 

// Async thunk to fetch logs
export const fetchLogs = createAsyncThunk(
  'logs/fetchLogs',
  async ({ searchKeyword }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/super-admin/raw-data/${searchKeyword}`);
      return response.data; 
    } catch (error) {
      if (error.response && error.response.data && error.response.data.msg) {
        return rejectWithValue(error.response.data.msg);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

const logsSlice = createSlice({
  name: 'logs',
  initialState: {
    rawData: [],   
    logs: [],      
    status: 'idle',  
    error: null,     
  },
  reducers: {
    clearLogs: (state) => {
      state.rawData = [];
      state.logs = [];
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // --- PENDING ---
      .addCase(fetchLogs.pending, (state) => {
        state.status = 'loading';
        state.error = null;
        state.rawData = [];
        state.logs = []; 
      })
      // --- FULFILLED ---
      .addCase(fetchLogs.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.rawData = action.payload.RawData || []; 
        state.logs = action.payload.Logs || [];
      })
      // --- REJECTED ---
      .addCase(fetchLogs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { clearLogs } = logsSlice.actions;
export default logsSlice.reducer;